import Vue from 'vue'
import msg from 'services/msg'

// makes this available to all Vue components
Vue.prototype.$msg = msg



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/init/msg.ts